import { API } from '../api'
import { Operator, OperatorsResponse } from './interface'

export const fetchAll = async (
  filtros: Record<string, any>
): Promise<{
  items: Operator[]
  total: number
}> => {
  try {
    const {
      dataLiberacaoFinal,
      dataLiberacaoInicial,
      idsEmpregadores,
      idsOperadoras,
      idsUnidades,
      paginaAtual,
      situacoes,
      tamanhoPagina,
      termo
    } = filtros

    const params = new URLSearchParams()
    idsOperadoras?.forEach(id => params.append('idsOperadoras', id))
    idsUnidades?.forEach(id => params.append('idsUnidades', id))
    situacoes?.forEach(id => params.append('situacoes', id))
    params.append('dataLiberacaoFinal', dataLiberacaoFinal)
    params.append('dataLiberacaoInicial', dataLiberacaoInicial)
    params.append('idsEmpregadores', idsEmpregadores || '')
    params.append('paginaAtual', paginaAtual)
    params.append('tamanhoPagina', tamanhoPagina)
    params.append('termo', termo || '')

    const response = await API.get<OperatorsResponse>(
      '/logistica/item/obter-geral',
      params
    )
    const results: Operator[] = response.content.agrupamentos ?? []

    const total = response.content.quantidadeTotal ?? 0

    return { items: results, total }
  } catch (error) {
    console.error('Erro ao buscar operadoras:', error)
    return { items: [], total: 0 }
  }
}
